import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import * as types from './types';
import _fetchLookbook from '../../../services/lookbook';
export default {
  fetchLookbook: function fetchLookbook(_ref, _ref2) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, query, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              query = _ref2.query;
              _context.next = 4;
              return _fetchLookbook(_this, query);

            case 4:
              data = _context.sent;
              commit(types.SET_LOOKBOOK, data);
              data = null;

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  appendAmbiences: function appendAmbiences(_ref3, _ref4) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var commit, query, data;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref3.commit;
              query = _ref4.query;
              commit(types.SET_LOADING_AMBIENCES, true);
              _context2.next = 5;
              return _fetchLookbook(_this2, query);

            case 5:
              data = _context2.sent;
              commit(types.APPEND_AMBIENCES, data);
              commit(types.SET_LOADING_AMBIENCES, false);
              data = null;

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  prependAmbiences: function prependAmbiences(_ref5, _ref6) {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var commit, query, data;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref5.commit;
              query = _ref6.query;
              commit(types.SET_LOADING_AMBIENCES, true);
              _context3.next = 5;
              return _fetchLookbook(_this3, query);

            case 5:
              data = _context3.sent;
              commit(types.PREPEND_AMBIENCES, data);
              commit(types.SET_LOADING_AMBIENCES, false);
              data = null;

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};